export default "__VITE_ASSET__006eac5a__"